<template>
<div class="table__wrapper">
  <table class="table">
    <thead>
      <tr>
        <th>Number</th>
        <th @click="$emit('sort', {col: 'name'})">Name</th>
        <th @click="$emit('sort', {col: 'device'})">Device</th>
        <th @click="$emit('sort', {col: 'file_name'})">File Name</th>
        <th @click="$emit('sort', {col: 'device'})">Upload</th>
        <td>Detections</td>
        <th>
            <div v-if="isAdmin" class="buttons">
                <!-- the first button here is a hack to position the second one properly -->
                <button class="button" style="visibility: hidden;"><span class="icon"><i class="fas fa-download"></i></span></button>
                <button
                    class="button"
                    :class="{
                        'is-primary': allBoxChecked,
                        'is-light': !allBoxChecked
                    }"
                    @click="handleAllBoxClick"
                >
                    <span v-if="allBoxChecked" class="icon">
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span v-else class="icon">
                        <i class="fa-solid fa-xmark"></i>
                    </span> 
                </button>
            </div>
        </th>
      </tr>
    </thead>
    <tfoot></tfoot>
    <tbody>
      <tr v-for="(sound, index) in sounds">
        <td>{{ index + 1 + ( page - 1 ) * limit }}</td>
        <td>{{sound.name}}</td>
        <td>{{sound.device}}</td>
        <td>{{sound.file_name}}</td>
        <td>{{soundUploadDate(sound)}}</td>
        <td>
            <DetectionsSpinner
                :sound-file-key="sound.object_key"
                :requesting-user="requesting_user"
                :fancy-spinner="sounds.length < 50">
            </DetectionsSpinner>
        </td>
        <td>
          <div class="buttons">
            <button class="button is-green" @click="$emit('downloadSound', {sound: sound})">
              <span class="icon"><i class="fas fa-download"></i></span>
            </button>

            <button
                v-if="isAdmin"
                class="button"
                :class="{
                    'is-primary': isChecked(sound),
                    'is-light': !isChecked(sound)
                }"
                @click="handleCheckboxClick(sound)"
            >
                <span v-if="isChecked(sound)" class="icon">
                    <i class="fa-solid fa-check"></i>
                </span>
                <span v-else class="icon">
                    <i class="fa-solid fa-xmark"></i>
                </span>          
            </button>

            <router-link
              class="button is-info"
              :to="{
                   name: 'soundDetailsPage',
                   params: {id: sound.object_key},
                   query: {user: requesting_user}}">
              <span class="icon"><i class="fas fa-edit"></i></span>
            </router-link>

            <DeleteFilesButton
                :rounded-edges="false"
                :files-to-delete="[sound.object_key]"
                :only-icon="true"
                :requesting-user="requesting_user"
                @files-deleted="onFilesDeleted">
            </DeleteFilesButton>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>


<script>
import { popItem } from '@/js/general'
import DetectionsSpinner from '@/components/sounds/detections/DetectionsSpinner.vue'
import DeleteFilesButton from '@/components/sounds/bulk-actions/DeleteFilesButton.vue'

export default {
    name: 'SoundTable',
    components: {DetectionsSpinner, DeleteFilesButton},
    emits: [
        'sort',
        'downloadSound',
        'fileDeleted',
        'update:modelValue',
    ],
    props: {
        sounds: {type: Object, default: {}},
        requesting_user: {type: String, default: ""},
        page: {type: Number, default: 1},
        limit: {type: Number, default: 10},
        modelValue: {type: Array, default: []},
        isAdmin: {type: Boolean, default: false},
    },
    data(){
        return {
            allBoxChecked: false,
        }
    },
    watch: {
        limit(){
            if(this.isAdmin){
                console.log('limit changed, clearing tick boxes')
                this.$emit('update:modelValue', [])
            }
        },
        modelValue: {
            handler(){
                // Work out if allBox should be checked or not
                if (this.modelValue.length < this.sounds.length){
                    this.allBoxChecked = false
                } else {
                    this.allBoxChecked = true
                }
            },
            deep: true // This is crucial for watching changes in arrays or objects
        },
    },
    methods: {
        soundUploadDate(sound){
            // parse date
            let sound_date = sound.date
            let min_offset = parseFloat(sound.time_offset) / 60
            let date = new Date(
                // date format in sound object: YYYYMMDD
                parseInt(sound_date.slice(0, 4)),
                parseInt(sound_date.slice(4, 6)) - 1,
                parseInt(sound_date.slice(6, 8)),
                Math.floor(min_offset / 60.0),
                Math.round(min_offset - Math.floor(min_offset / 60.0) * 60)
            )
            return Intl.DateTimeFormat('en-GB', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            }).format(date)
        },
        handleCheckboxClick(sound){
            let fileList = this.modelValue
            //if the file was not checked, add it
            if (!this.isChecked(sound)){
                fileList.push(sound)
            }
            // if the file was already checked, remove it
            else {
                this.allBoxChecked = false
                fileList = popItem(sound, fileList)
            }
            // Update the parent component with the updated file list
            this.$emit('update:modelValue', fileList)
        },
        handleAllBoxClick(){
            let fileList = this.modelValue
            // if it was already checked, uncheck it
            if (this.allBoxChecked === true){
                this.allBoxChecked = false
                fileList = []
            }
            // if it wasn't checked, make it true
            else {
                this.allBoxChecked = true
                for (const sound of this.sounds){
                    if (!fileList.includes(sound)){
                        fileList.push(sound)
                    }
                }
            }
            // Update the parent component with the updated file list
            this.$emit('update:modelValue', fileList)

        },
        isChecked(sound){
            return this.modelValue.includes(sound)
        },
        onFilesDeleted(responses){
            this.$emit('fileDeleted', responses)
        },
    },
}
</script>

<style>
.table__wrapper {
    overflow-x: auto;
}
</style>

